/**
 * In local dev, proxy Coral through Next so embed GraphQL is same-origin (avoids CORS).
 * See `next.config.js` rewrites for `/coral-proxy/*`.
 */
export function getCskCoralRootUrl(coralOrigin: string): string {
  if (process.env.NODE_ENV !== "development" || typeof window === "undefined") {
    return coralOrigin;
  }
  return `${window.location.origin}/coral-proxy`;
}
